import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarSelected = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 26,
	viewBox: "0 0 28 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 21.0267L22.24 26.0001L20.0533 16.6267L27.3333 10.3201L17.7466 9.50675L14 0.666748L10.2533 9.50675L0.666626 10.3201L7.94663 16.6267L5.75996 26.0001L14 21.0267Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgStarSelected);
export default ForwardRef;
